const TEXT_INPUT_TYPES = [
  "text",
  "email",
  "password",
  "search",
  "tel",
  "url",
  "number",
];

export function isWebsiteBuilderTextEditableTarget(target: EventTarget): boolean {
  return (
    (target instanceof HTMLInputElement && TEXT_INPUT_TYPES.includes(target.type)) ||
    target instanceof HTMLTextAreaElement ||
    (target instanceof HTMLElement && target.isContentEditable)
  );
}